import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnChanges {
  @Input() pageType: any;
  @Input() searchInput: string;
  @Output() searchItem = new EventEmitter<any>();
  placeHolder: any;
  search = new FormControl('');

  private _subscription: Subscription;
  private _valueChangesSubscription: Subscription;

  constructor(private _dataSer: DataService, private translate: TranslateService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'clearFilter') {
        this.search.reset();
      }
    });
  }

  ngOnChanges(): void {
    
    if (this.searchInput !== undefined) {
      this.search.setValue(this.searchInput);
    }
    switch (this.pageType) {
      case 'users':
        this.placeHolder = 'Name/Email/EmpId';
        break;
      case 'ptw':
        this.placeHolder = 'Employee Name/Employee Id';
        break;
      case 'vehicle':
        this.placeHolder = 'Entity Id/Make/Model';
        break;
      case 'wiki':
        this.placeHolder = 'Title/Tags/KB ID';
        break;
      case 'devices-site':
        this.placeHolder = 'Site Name';
        break;
      case 'entities':
        this.placeHolder = 'UniqueId/Name/Category';
        break;
      case 'developer':
        this.placeHolder = 'Entity ID';
        break;
      case 'monotainer':
        this.placeHolder = 'Active TagId/UniqueId/Name/Category';
        break;
      case 'tracker':
        this.placeHolder = 'Chassis No/Segment/STR';
        break;
      case 'entity':
        this.placeHolder = 'Chassis No/Segment/STR';
        break;
      case 'filter-panel':
        this.placeHolder = 'Unique ID/Category/Name';
        break;
      case 'dtc':
        this.placeHolder = 'DTC ID';
        break;
      case 'case':
        this.placeHolder =
          `DTC ID/Case ID/ Chassis Number/${this.fetchProtusTitle()}`;
        break;
      case 'zone-planogram':
        this.placeHolder = 'Worktable/Status';
        break;
      case 'events-vot':
        this.placeHolder = 'Chassis Number/Name/Description';
        break;
      case 'protusHistory':
        this.placeHolder = 'DTC ID/ Chassis Number ';
        break;
      case 'audit-history':
        this.placeHolder = 'Action/ Source';
        break;
      default:
        this.placeHolder = 'Search';
        break;
    }
    this._valueChangesSubscription = this.search.valueChanges
      .pipe(debounceTime(500))
      .subscribe((data) => {
        if (
          data !== null &&
          ((data.length && data.substr(data.length - 1) !== ' ') ||
            !data.length)
        ) {
          this.searchItem.emit(data);
        }
      });
  }

  /**
   * Fetchs protus number title dynamically using translation
   * @returns  
   */
  fetchProtusTitle() {
    const key = 'protusNumber';
    const translation = this.translate.instant(key);
    return (translation && translation !== key) ? translation : 'Protus Number';
  }

  clearSearch() {
    this.search.reset();
    this.searchItem.emit(this.search.value);
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    if (this._valueChangesSubscription)
      this._valueChangesSubscription?.unsubscribe();
  }
}
